"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SPREADSHEET: [
        'xlsx',
        'xlm',
        'xlsm',
        'xlm',
        'xlsb',
        'xltx',
        'xlm',
        'xml',
        'xltm',
        'xlm',
        'xls',
        'xlt',
        'xls',
        'xlam',
        'xlm',
        'xla',
        'xlw',
        'xlr',
        'csv'
    ],
    TEXT: [
        'txt',
        'doc',
        'docx',
        'dot',
        'w60',
        'w61',
        'wiz',
        'word',
        'wp',
        'wp5',
        'wp6',
        'wpd',
        'text'
    ],
    IMAGE: [
        'bm',
        'bmp',
        'gif',
        'ico',
        'ief',
        'iefs',
        'jfif',
        'jpe',
        'jpeg',
        'jpg',
        'jps',
        'nif',
        'niff',
        'pbm',
        'pct',
        'pcx',
        'pic',
        'pict',
        'png',
        'ppm',
        'svf',
        'svg',
        'tif',
        'tiff',
        'wbmp',
        'xif',
        'xpm',
        'x-png',
        'xwd'
    ],
    PRESENTATION: ['pot', 'ppa', 'pps', 'ppt', 'pwz'],
    PDF: ['pdf'],
    DWG: ['dwg'],
    IFC: ['ifc'],
    ZIP: ['zip', '7z', 'rar']
};
